import { render, staticRenderFns } from "./Najvaznije.vue?vue&type=template&id=a4b78524&scoped=true&"
import script from "./Najvaznije.vue?vue&type=script&lang=js&"
export * from "./Najvaznije.vue?vue&type=script&lang=js&"
import style0 from "./Najvaznije.vue?vue&type=style&index=0&id=a4b78524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b78524",
  null
  
)

export default component.exports